import { createTransform } from "redux-persist";
import LS from "../../../utils/LocalStorage";
import { LocalStorageEnum } from "../../../utils/enums";

const EXPIRE_TIME = 6 * 60 * 60 * 1000; // Expires after 6 hours

export const customerShortIdExpireTransform = createTransform<
  string | undefined,
  string | { value: string; _persistedAt: number } | undefined
>(
  (inboundState) => {
    if (!inboundState) {
      return inboundState;
    }

    const wrapped = {
      value: inboundState as string,
      _persistedAt: Date.now(),
    };

    return wrapped as any;
  },

  (outboundState: any) => {
    if (!outboundState) {
      return outboundState;
    }

    if (typeof outboundState === "string") {
      return outboundState;
    }

    if (outboundState.value && outboundState._persistedAt) {
      const currentTime = Date.now();
      const age = currentTime - outboundState._persistedAt;

      if (age > EXPIRE_TIME) {
        // Clear localStorage values when expired
        LS._delete(LocalStorageEnum.USER_NAME);
        LS._delete(LocalStorageEnum.PHONE_NUMBER);
        LS._delete(LocalStorageEnum.COUNTRY_CODE);

        return undefined;
      }

      // Return the string value, not the wrapped object
      return outboundState.value;
    }

    return outboundState;
  },

  { whitelist: ["customerShortId"] }
);
